import GameInfo from './GameInfo.vue';

// @ts-ignore
GameInfo.install = (Vue) => {
  Vue.component((GameInfo as any).options.name, GameInfo);
};

export default GameInfo;
